module.exports = __webpack_public_path__ + "img/20220217140235179eov.c5b6ab30.png";